<template>
    <div>
        <div v-if="showLoading" class="loading"></div>
    </div>
</template>
<script>
export default {
	name: 'app-loading',
	props: {
		showLoading: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading::after {
  content: '';
  width: 40px;
  height: 40px;
  border: 5px solid transparent;
  border-top: 5px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/app-loading.vue